export default __webpack_public_path__ + "static/media/image-board-study-pattern-n-m@2x.492be8b3.webp";